import { useTranslation } from 'react-i18next';
import { IMG_PATH } from 'constants/config';

const data = [
  {
    title: '耗時耗力',
    text: ['花了時間資源，', '卻沒有信心是否有績效'],
  },
  {
    title: '人性難滅',
    text: ['賺錢抱不住，賠錢一直抱', '無法克制自我人性'],
  },
  {
    title: '不知何時進出場',
    text: ['常常買在最高，賣在最低，進出場時機沒有把握'],
  },
];

const img = `${IMG_PATH}/dilemma`;

function Dilemma() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center py-12">
      <div className="text-4xl mb-12">{t('現有交易困境')}</div>

      <div className="w-full space-y-8 sm:space-y-0 sm:space-x-8 sm:flex justify-around">
        {data.map(({ title, text }, index) => (
          <div key={index} className="flex flex-col items-center sm:w-1/5">
            <img src={`${img}${index}.png`} alt="" />

            <div className="text-2xl text-apricot my-8">{t(title)}</div>

            <div className="w-3/5 text-center sm:w-full sm:space-y-6">
              {text.map((str) => (
                <div key={str} style={{ color: '#556270' }}>
                  {t(str)}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Dilemma;
